import { render, staticRenderFns } from "./HeaderDiscountBanner.vue?vue&type=template&id=6ecb5892&scoped=true&"
import script from "./HeaderDiscountBanner.vue?vue&type=script&lang=js&"
export * from "./HeaderDiscountBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb5892",
  null
  
)

export default component.exports